// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__10MRN","icon":"SortAdornment_icon__34951","up":"SortAdornment_up__1t0rI","down":"SortAdornment_down__2ajKK","active":"SortAdornment_active__219hr"};